import { EventCategory, EventType, UserType } from '@shared/types/stats';

import StreamingService from '../streaming';

import { gtmService } from '.';

const mediaStreamController = StreamingService.mediaStreamController;

export const gtmUserLogin = async (id: string) => {
    const { addData } = gtmService();
    await addData({
        event: 'userLogin',
        date: new Date().getTime(),
        id,
    });
};

const sendEvent = (data: Record<string, unknown>) => {
    const { addData } = gtmService();

    const isVideoOn = mediaStreamController.isVideoOn;
    const isAudioOn = mediaStreamController.isAudioOn;

    addData({ microphone_status: isAudioOn, camera_status: isVideoOn, ...data }).catch((e) => console.error(e));
};

export const sendControlsEvent = (
    event: 'camera_turn_on' | 'camera_turn_off' | 'microphone_turn_on' | 'microphone_turn_off',
    data: Record<string, unknown>
): void => {
    sendEvent({
        ...data,
        event,
        eventCategory: EventCategory.Controls,
    });
};

export const sendRoomUserEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.RoomUser,
    });
};

export const sendPaymentsEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.Payments,
    });
};

export const sendAutoPaymentsEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.AutoPayments,
    });
};

export const sendUserGiftEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.RoomUserGift,
    });
};

export const sendModelGiftEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.RoomModelGift,
    });
};

export const sendGdprEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.Gdpr,
    });
};

export const sendRegistrationEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.Registration,
    });
};

export const sendVerificationEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.Verification,
    });
};

export const sendRatingModalEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.Rating,
    });
};

export const sendRoomModelEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.RoomModel,
    });
};

export const sendStreamEvent = (userType: UserType, data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        user_type: userType,
        eventCategory: EventCategory.Stream,
    });
};

export const sendStreamProviderEvent = (type: EventType, duration: number) => {
    sendEvent({
        type,
        duration,
        eventCategory: EventCategory.StreamProvider,
    });
};

export const sendFavoritesEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.Favorites,
    });
};

export const sendCallEvent = (data: Record<string, unknown>) => {
    sendEvent({
        ...data,
        eventCategory: EventCategory.Call,
    });
};

export const sendFlipSelfVideo = (isMain: boolean) => {
    sendEvent({
        event: isMain ? EventType.StreamMyPicIsSmall : EventType.StreamMyPicIsBig,
        eventCategory: EventCategory.Unknown,
    });
};

export const sendPmEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.Pm,
    });
};

export const sendLoginEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.Login,
    });
};

export const sendAccountEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.Account,
    });
};

export const sendUserNotesEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.UserNotes,
    });
};

export const sendStoriesEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.Stories,
    });
};

export const sendReportEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.Report,
    });
};

export const sendPermissionsEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.Permissions,
    });
};

export const sendConnectionLostEvent = (data: Record<string, unknown>) => {
    return sendEvent({
        ...data,
        eventCategory: EventCategory.ConnectionLost,
    });
};

export const sendBlockingEvent = (type: UserType, data: Record<string, unknown>) => {
    return sendEvent({
        event: 'ga4_event',
        ...data,
        eventCategory: type === UserType.Model ? EventCategory.ModelBlocked : EventCategory.UserBlocked,
    });
};

export const sendUnblockingEvent = (type: UserType, data: Record<string, unknown>) => {
    return sendEvent({
        event: 'ga4_event',
        ...data,
        eventCategory: type === UserType.Model ? EventCategory.ModelUnblocked : EventCategory.UserUnblocked,
    });
};
